module.exports = __webpack_public_path__ + "static/media/swasti.25ce9994.png";